import _ from 'lodash'
import safeAwait from '../../../../../lib/safeAwait'
import { httpHandler } from '../../../../../lib/errorHelper'
import { LISTING_TYPE } from '../../../Dashboard/OperatingDashboard/constants/listing'
import { FIELD } from './index'
import { FIELD as RANKING_TABLE_FIELD } from './RankingTable/RankingTable'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { removeNotAlphanumericAndComma } from '../../../../lib/parser'
import moment from 'moment'
import { DATE_FORMAT } from '../../../../lib/MomentHelper'
import { RANKING_SIZE, LISTING_IDS_LIMIT } from './constants'

export const getInitialTimeRange = () => {
  const now = moment()
  const endHour = moment(now).subtract(1, 'hour').startOf('hour').subtract(1, 'second')
  const startHour = moment(endHour).subtract(24, 'hours').add(1, 'second')

  return {
    reportDateStart: startHour.utc().format(DATE_FORMAT.API_TIMEZONE_DATETIME),
    reportDateEnd: endHour.utc().format(DATE_FORMAT.API_TIMEZONE_DATETIME)
  }
}

export const getListingIdsArray = (listingIds) => {
  const cleanValue = removeNotAlphanumericAndComma(listingIds)
  return _.compact(_.split(cleanValue, COMMA))
}

export const getNotFoundListingIds = (formValues, rankingData) => {
  const isNeedNotFoundIds = (
    formValues[FIELD.LISTING_TYPE] === LISTING_TYPE.ORDER
  )
  let notFoundListingIds = isNeedNotFoundIds
    ? _.xor(
      getListingIdsArray(formValues[FIELD.LISTING_IDS]),
      _.map(rankingData, item => item[RANKING_TABLE_FIELD.LISTING_ID])
    )
    : []
  notFoundListingIds = _.join(notFoundListingIds, COMMA)
  return notFoundListingIds
}

export const transformSellersRankings = (sellersRankings, rankingSize) => {
  return _.flow(
    valuableData => _.map(valuableData, (item, index) => ({
      ...item,
      ranking: index + 1,
      soldAmount: +item.soldAmount || 0,
      soldQuantity: +item.soldQuantity || 0,
      pageView: +item.pageView || 0,
      uniqueUser: +item.uniqueUser || 0,
      conversionRate: +item.conversionRate || 0,
      availableQuantity: +item.availableQuantity || 0,
      price: +item.price || 0
    })),
    pureData => _.slice(pureData, 0, rankingSize)
  )(sellersRankings)
}

export const getBestsellerRankings = async ({
  fetchSePaginationBestsellers,
  reportDateStart,
  reportDateEnd,
  listingType,
  listingIds,
  sortType,
  formParams
}) => {
  const isSpecificListing = listingType === LISTING_TYPE.ORDER && listingIds
  const limit = isSpecificListing ? LISTING_IDS_LIMIT : RANKING_SIZE

  const bestsellerParams = {
    reportDate: `${reportDateStart}/${reportDateEnd}`,
    sort: `-${sortType}`,
    limit,
    realTime: true
  }

  if (isSpecificListing) {
    bestsellerParams.listingIds = listingIds
  }

  const [bestsellerError, bestsellerPayload] = await safeAwait(
    fetchSePaginationBestsellers(bestsellerParams).then(httpHandler)
  )

  if (bestsellerError) {
    return [bestsellerError, null]
  }

  const bestsellers = _.get(bestsellerPayload, 'bestsellers', [])
  const allRankings = transformSellersRankings(bestsellers, limit)
  const notFoundListingIds = getNotFoundListingIds(formParams, allRankings)
  // 取前五筆資料顯示在賣場排行
  const topRankings = allRankings.slice(0, RANKING_SIZE)

  return [null, { rankings: topRankings, notFoundListingIds }]
}
